import {useState} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {getUserList} from "api-v3";
import * as request from "api-socket/chat";
import classNames from "classnames/bind";
import BackIcon from "images/search_head_back.svg";
import CloseIcon from "images/search_head_close.svg";
import SearchIcon from "images/search_input_icon.svg";
import profileDefaultImage from "images/common/avatar-default-profile-image.png";
import styles from "./index.module.scss";

function PersonalChatSearch({intl, currentUser, onClickClose, onClickUser, handleSearchMode, onSubmit}) {
  const cn = classNames.bind(styles);
  const [searchList, setSearchList] = useState([]);
  const defaultIcon = profileDefaultImage;

  const getActiveUser = async list => {
    const data = JSON.stringify(list);
    request
      .postActiveUser({data})
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setSearchList(data.list);
        }
      });
  };

  const getUsersByName = async name => {
    const response = await getUserList({name: name});
    getActiveUser(response.data.items);
  };

  return (
    <div className={styles.search_popup}>
      <div className={styles.buttons_head}>
        <button type="button" className={styles.prev_btn} onClick={handleSearchMode}>
          <img alt="prev icon" src={BackIcon} />
        </button>
        <button className={styles.close_btn} onClick={onClickClose} type="button">
          <img alt="close icon" src={CloseIcon} />
        </button>
      </div>

      <div className={styles.search_box}>
        <div className={styles.search_input_wrap}>
          <button className={styles.search_icon} type="button">
            <img alt="search icon" src={SearchIcon} />
          </button>
          <input
            type="text"
            className={styles.search_input}
            placeholder={intl.formatMessage({
              id: "ID_SEARCH_INPUT_PLACEHOLDER",
            })}
            onKeyDown={e => e.key === "Enter" && getUsersByName(e.target.value)}
          />
        </div>

        <div className={styles.search_result_wrap}>
          <ul className={styles.search_result_list}>
            {searchList?.map((user, i) => (
              <li key={i} className={cn("search_result_item", user.ci === currentUser?.ci && "active")} onClick={() => onClickUser(user)}>
                <div className={cn("search_result_user", user.isWorldConnecting && "active")}>
                  <img alt="user avatar" src={user.icon || defaultIcon} />
                </div>
                <p className={styles.search_result_nickname}>{user.name}</p>
              </li>
            ))}
          </ul>
          {searchList && searchList.length === 0 && (
            <p className={styles.search_no_data}>
              <FormattedMessage id="ID_SEARCH_NO_DATA" />
            </p>
          )}
        </div>
        <button className={cn("start_chat", currentUser && "active")} type="button" onClick={onSubmit}>
          <FormattedMessage id="ID_SEARCH_POPUP_START_CHAT" />
        </button>
      </div>
    </div>
  );
}

export default injectIntl(PersonalChatSearch);
